import React from 'react'
import { createPortal } from 'react-dom'
import WithToggle, { ToggleContext, toggleContext } from './WithToggle'

interface PortalProps {
  containerSelector: string
  content: React.ReactNode
}

export function Portal({ containerSelector, content }: PortalProps) {
  const container = document.querySelector(containerSelector)

  if (!container) {
    return null
  }

  return createPortal(
    content,
    document.querySelector(containerSelector) as Element
  )
}

interface TogglePortalProps extends PortalProps {
  initialStatus?: boolean
  trigger: React.ReactNode | ((props: ToggleContext | null) => React.ReactNode)
}

export function TogglePortal({
  initialStatus = false,
  trigger,
  ...props
}: TogglePortalProps) {
  return (
    <WithToggle initialStatus={initialStatus}>
      <toggleContext.Consumer>
        {(toggle) => (
          <>
            {typeof trigger === 'function' ? trigger(toggle) : trigger}
            {toggle?.isActive && <Portal {...props} />}
          </>
        )}
      </toggleContext.Consumer>
    </WithToggle>
  )
}
